// Inflos brand tokens, the same values the marketplace uses (frontend
// common/theme/brand.ts). Ink on a warm ground; leaf for done or healthy,
// coral text on bone for needs-you, royal red for danger; coral itself only for
// the one money action on a screen.
export const C = {
  ink: "#0E0E0E",
  ink2: "#55524F",
  muted: "#6B655F",
  faint: "#9A938D",
  line: "#EDEBEB",
  line2: "#DDCEC1",
  paper: "#FFFFFF",
  ground: "#F6F4F2",
  head: "#FBFAF9",
  bone: "#FFEDDE",
  bone1: "#FFF6EE",
  leaf: "#3F7A57",
  leafTint: "#EEF6F1",
  moss: "#1F3D2B",
  mint: "#85E8AD",
  coral: "#F5734D",
  coralText: "#B33A12",
  danger: "#7D001C",
  dangerTint: "#FBEAEE",
  side: "#0E0E0E",
  sideText: "#CFC8C1",
  sideActive: "#262626",
} as const;

export const R = { ctl: 6, box: 8, tag: 5, dialog: 12 } as const;

export const DISPLAY_FONT = '"Bricolage Grotesque", "Public Sans", system-ui, sans-serif';
export const BODY_FONT = '"Public Sans", "Noto Sans Thai", system-ui, -apple-system, "Segoe UI", sans-serif';
